export default class Map {
  constructor(element) {
    this.element = element;
    this.maxZoom = 15;
    this.buttons = this.element.querySelectorAll('.map-btn');
    this.map = L.map('map').setView([45.538369, -73.492302], this.maxZoom);
    this.map.dragging.enable();
    this.init();
  }

  init() {
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(this.map);

    //ajoute event listener sur les boutons et les marqueur sur la map
    for (let i = 0; i < this.buttons.length; i++) {
      const button = this.buttons[i];
      try {
        let marker = L.marker([
          button.dataset.coordLat,
          button.dataset.coordLong,
        ]).addTo(this.map).bindPopup(button.dataset.adresse);
      } catch (error) {
        return;
      }

      button.addEventListener('click', this.viewPlace.bind(this));
    }
  }

  viewPlace(event) {
    let place = event.currentTarget;
    this.map.flyTo(
      [place.dataset.coordLat, place.dataset.coordLong],
      this.maxZoom,
    );
  }
}
